import { getAddress, isAddress } from 'ethers';

export function normalizeEvmAddress(address: string): string | null {
  if (!isAddress(address)) {
    return null;
  }

  return getAddress(address);
}
